(() => {
  const section = document.getElementById('iphone-guide');
  if (!section || section.dataset.guideParallaxReady) return;
  section.dataset.guideParallaxReady = 'true';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 750px)');
  let visible = false;
  let frame = 0;
  const reset = () => {
    ['--guide-phone-shift', '--guide-copy-shift', '--guide-wash-shift'].forEach(name => section.style.removeProperty(name));
  };
  const paint = () => {
    frame = 0;
    if (reduceMotion.matches || !desktop.matches) { reset(); return; }
    if (!visible) return;
    const box = section.getBoundingClientRect();
    const progress = Math.max(-1, Math.min(1, (window.innerHeight / 2 - box.top - box.height / 2) / ((window.innerHeight + box.height) / 2)));
    section.style.setProperty('--guide-phone-shift', `${(progress * -22).toFixed(2)}px`);
    section.style.setProperty('--guide-copy-shift', `${(progress * 12).toFixed(2)}px`);
    section.style.setProperty('--guide-wash-shift', `${(progress * 36).toFixed(2)}px`);
  };
  const queue = () => { if (!frame) frame = window.requestAnimationFrame(paint); };
  const observer = new IntersectionObserver(entries => {
    visible = entries[0].isIntersecting;
    if (visible) queue();
  }, { rootMargin: '120px' });
  observer.observe(section);
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue, { passive: true });
  reduceMotion.addEventListener('change', queue);
  desktop.addEventListener('change', queue);

})();
